import { ICommandBase } from '@/commands/interface/iCommandBase';
import { SimpleTextLayer } from '@/model/document2/page/surface/design/layer/simpleTextLayer';
import { TextInfo } from '@/utilityModels/textInfo';

// シンプルテキストレイヤーの文法情報全変更コマンド
export class ChangeSimpleTextLayerTextInfoCommand implements ICommandBase
{
    private layer! : SimpleTextLayer;
    private propertyName! : string;
    private value! : any;
    private doneCallback! : () => void;

    private oldTextInfoArray;
    private oldBaseTextInfo;

    constructor(layer : SimpleTextLayer, propertyName : string, value : any, doneCallback : () => void)
    {
        this.layer = layer;
        this.propertyName = propertyName;
        this.value = value;
        this.doneCallback = doneCallback;

        // 現在の値を保持
        this.oldBaseTextInfo = layer.baseTextInfo;
    }

    public do() : void
    {
        var newBaseTextInfo = this.layer.baseTextInfo.clone();
        newBaseTextInfo[this.propertyName] = this.value;
        // 新しい値を設定
        this.layer.baseTextInfo = newBaseTextInfo;

        this.doneCallback();
    }

    public undo() : void
    {
        // プロパティに前の値を設定
        this.layer.baseTextInfo = this.oldBaseTextInfo;

        this.doneCallback();
    }

    public redo() : void
    {
        var newBaseTextInfo = this.layer.baseTextInfo.clone();
        newBaseTextInfo[this.propertyName] = this.value;
        // 新しい値を設定
        this.layer.baseTextInfo = newBaseTextInfo;
        
        this.doneCallback();
    }
}